import { IGoogleCredential } from "@kimbocare/core";

export interface Login {
  identifiant: string;
  date: any;
  source: string;
  work_email?: string;
  code?: number;
  mode?: string;
  work_code?: number;
  key?: string | undefined; // param for user invitation in group
  googgle_token?: string | undefined; // param for google login
  totp_code?: number
  language_id?: number;
}

export interface VerificationRegister {
  first_name: string;
  last_name: string;
  email?: string;
  work_email?: string;
  tel?: string;
  language_id: number;
  country: string;
  has_work_email: boolean;
  date: any;
  is_google_auth: boolean;
  googgle_token?: string | undefined; // param for google login
}

export class IGoogleLogin {
  google_token: string;
  country: string;
  language_id: number;
  email: string;
  constructor(token: string, country: string, language_id: number, email: string) {
    this.google_token = token;
    this.country = country;
    this.language_id = language_id;
    this.email = email
  }
}

export class KSocialUser {
    provider: string;
    id: string;
    email: string;
    name: string;
    photoUrl: string;
    firstName: string;
    lastName: string;
    idToken: string;
    
    constructor(
      provider: string,
      id: string,
      email: string,
      name: string,
      photoUrl: string,
      firstName: string,
      lastName: string,
      idToken: string
    ) {
      this.provider = provider;
      this.id = id;
      this.email = email;
      this.name = name;
      this.photoUrl = photoUrl;
      this.firstName = firstName;
      this.lastName = lastName;
      this.idToken = idToken;
    }
}

export declare class IGoogleSocial {
    googleobject: IGoogleCredential;
    token: string;
    user?: KSocialUser;
    country?: null;
    constructor(googleobject: IGoogleCredential, token: string, user?: KSocialUser, country?: null);
}


